module.exports = __webpack_public_path__ + "static/koala-9903e7b791f50ffbde786f5a1406ca69.png";